import React, { Fragment, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import '../Workflow.scss'
import { TaskStatus } from '../../../services/TaskStatus';
import { useTaskStatus } from '../../hooks/useTaskStatusHook';
import { WorkflowTasks, SuccessfulStatus } from '../../../services/WorkflowTasks';
import PrepareReturnVirApi from '../../../../../services/api/prepareReturnVirApi';
import WorkflowTask from '../../../../../components/library/workflow-tasks/WorkflowTask'
import WorkflowTaskDescriptionWithHelp from '../../../../../components/library/workflow-tasks/WorkflowTaskDescriptionWithHelp';
import TicketActions from '../../../../../store/ticketRedux';
import Button from '../../../../../components/library/buttons/Button';
import DoxExplorer from '../../dox/Explorer/doxExplorer';
import DoxUploader from '../../dox/Uploader/doxUploader';
import { useTicketState } from '../../hooks/useTicketStateHook';
import { useInterviewInfo } from '../../hooks/useInterviewInfoHook';
import { createInProgressTaskCompletionObject } from '../../../services/prepare/PrepareUtils';
import TaskErrorText from '../../../../../components/library/workflow-tasks/TaskErrorText';

const ClientCallPaymentVirTask = (props) => {
    const ticketIsOpen = useTicketState(props.ticket);
    const [baseStatus, completions] = useTaskStatus(props.ticket, [WorkflowTasks.CLIENT_CALL_PAYMENT_VIR]);
    const [status, setStatus] = useState(TaskStatus.NOT_STARTED)
    const [hasUploaderError, setHasUploaderError] = useState(false);
    const [sendingReadyToFile, setSendingReadyToFile] = useState(false)
    const [uploaderOpen, setUploaderOpen] = useState(false);
    const [explorerShowing, setExplorerShowing] = useState(false);
    const [hasUploadedFiles, setHasUploadedFiles] = useState(false);
    const [returnType, , , primaryName ] = useInterviewInfo(props.ticket);
    const [errorList, setErrorList] = useState([]);
    const [sendingReadyToFileError, setSendingReadyToFileError] = useState(false)
    const [disableReadyToFile, setDisableReadyToFile] = useState(false)
    const dispatch = useDispatch();
    const api = PrepareReturnVirApi.create();
            
    useEffect(() => {
        var confirmReadyToFile = props.ticket.taskCompletionStates.filter(x => x.workflowTaskId === WorkflowTasks.VIR_READY_TO_FILE)
        var confirmASigning = props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.RC71_P && y.status.toUpperCase() === SuccessfulStatus).length > 0 &&
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.POA_P).length > 0 &&
            props.ticket.taskCompletionStates.filter(y => y.workflowTaskId === WorkflowTasks.RETURN_REVIEWED).length > 0;

        if (confirmReadyToFile.length !== 0 || !confirmASigning) {
            setDisableReadyToFile(true)
        }

        if (confirmASigning) {
            setStatus(TaskStatus.IN_PROGRESS);
        }

        if (confirmReadyToFile.length > 0) {
            setStatus(TaskStatus.COMPLETE);
        }

    }, [props.ticket])

    const showUploader = () => {
        setUploaderOpen(true)
        if (status === TaskStatus.NOT_STARTED) {
            setStatus(TaskStatus.IN_PROGRESS);
        }
    }

    const onCloseUploader = () => {
        setUploaderOpen(false);
    }

    const onUploadsComplete = async (filesWereUploaded) => {
        if (filesWereUploaded) {
            setHasUploadedFiles(true);

            var payload = createInProgressTaskCompletionObject(
                (completions || []).find(x => x.status !== TaskStatus.INVALID), null, true);
        }

        setUploaderOpen(false);
    }

    const showExplorer = () => {
        setExplorerShowing(true)
    }

    const onExplorerClose = () => {
        setExplorerShowing(false)
    }

    const onReadyToFileComplete = () => {
        props.onReadyToFile(true)
    }

    const handleReadyToFile = async () => {
        if (status === TaskStatus.NOT_STARTED) {
            setStatus(TaskStatus.IN_PROGRESS);
        }
        if (props.ticket) {
            setSendingReadyToFile(true)
            setSendingReadyToFileError(false)

            var response = await api.sendForReadyToFilePaymentTask(props.ticket.id)
            if (response && response.ok) {
                if (response.data.statusCode === 'SUCCESS') {
                    dispatch(TicketActions.getTicket(props.ticket.id))
                    setDisableReadyToFile(true)
                    if (status === TaskStatus.IN_PROGRESS) {
                        setStatus(TaskStatus.COMPLETE);
                    }
                    onReadyToFileComplete()
                }
                else {
                    if (response.data.statusCode.includes('_Receipt_'))
                        setSendingReadyToFileError(true)
                }
            }

            setSendingReadyToFile(false)
        }        
    }   

    return (
        <WorkflowTask status={status} taskId={WorkflowTasks.CLIENT_CALL_PAYMENT_VIR}>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    descriptions={['ClientCallPaymentVirTask.Step5', 'ClientCallPaymentVirTask.Step5Info']} />                
            </div>
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns'>
                <WorkflowTaskDescriptionWithHelp
                    descriptions={['ClientCallPaymentVirTask.Step6', 'ClientCallPaymentVirTask.Step6Info']} />
            </div>            
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    {props.ticket &&
                        <Fragment>
                            <div className='step-center-container'>
                                <Button
                                    elementId='client-call-doc-manage-btn'
                                    labelKey='DocUploadTask.ViewManage'
                                    buttonStyles='secondary'
                                    onClick={showExplorer}
                                />
                                <Button
                                    elementId='client-call-doc-upload-btn'
                                    labelKey='PrepareTask.UploadDocs'
                                    buttonStyles='secondary'
                                    onClick={showUploader}
                                    disabled={status === TaskStatus.COMPLETE || !ticketIsOpen}
                                />
                            </div>
                            {hasUploaderError &&
                                <TaskErrorText errorKey='PrepareTask.ErrorUploader' />
                            }
                        </Fragment>
                    }
                </div>                
            </div>
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    <div className='prep-border' />
                </div>
            </div>
            <div className='columns'>
                <div className='column is-offset-1 is-10'>
                    <div className='step-center-container'>
                        <Button
                            elementId='prepare-done-btn'
                            labelKey='ClientCallPaymentVirTask.ReadyToFile'
                            buttonStyles='secondary'
                            onClick={handleReadyToFile}
                            disabled={disableReadyToFile}
                            loading={sendingReadyToFile}
                        />
                    </div>
                    <div>{sendingReadyToFileError &&
                        <TaskErrorText errorKey='ClientCallPaymentVirTask.ErrorReadyToFile' />
                    }</div>
                </div>                
            </div>           
            <DoxExplorer ticket={props.ticket} show={explorerShowing}
                onClose={onExplorerClose}
            />
            <DoxUploader ticket={props.ticket} show={uploaderOpen}
                layoutType={'desktop'} onUploadsComplete={onUploadsComplete} onClose={onCloseUploader}
            />
        </WorkflowTask>
    );
}

ClientCallPaymentVirTask.whyDidYouRender = false;

ClientCallPaymentVirTask.propTypes = {
    ticket: PropTypes.object
}

export default ClientCallPaymentVirTask